// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__364_W","placeholdersHeader":"styles_placeholdersHeader__T9Awo","editorStyle":"styles_editorStyle__2JB6d","placeholdersBox":"styles_placeholdersBox__1ZqdF"};